import keyMirror from 'keymirror';

import { ListingOfferChannel } from '../declarations';

export const LISTING_OFFER_CHANNELS: { [K in ListingOfferChannel]: K } = keyMirror({
  brokerage: true,
  brokerage_referral: true,
  direct: true,
  reit: true,
});
